import React, { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { useAuth } from "../auth";

const DEMO_ACCOUNTS = [
  { role: "Owner", email: "owner@sage.school", password: "owner123", note: "Full access — start here" },
  { role: "Staff", email: "staff@sage.school", password: "staff123", note: "Front office" },
];

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const [showDemo, setShowDemo] = useState(true);   // popup opens on load

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault(); setErr(""); setBusy(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (e) {
      setErr(e?.response?.data?.detail || "Login failed");
    } finally { setBusy(false); }
  };

  const fillAccount = (acc) => {
    setEmail(acc.email);
    setPassword(acc.password);
    setShowDemo(false);
  };

  return (
    <div className="auth-shell">
      <form className="auth-card" onSubmit={submit}>
        <div className="auth-brand">
          <div className="brand-mark">S</div>
          <h1>Sage</h1>
          <p>Sign in to your account</p>
        </div>

        {err && <div className="error-banner">{err}</div>}

        <div className="form-row">
          <label>Email</label>
          <input className="input" type="email" value={email}
                 onChange={(e) => setEmail(e.target.value)}
                 placeholder="you@sage.school"
                 autoComplete="email" autoFocus required/>
        </div>
        <div className="form-row">
          <label>Password</label>
          <input className="input" type="password" value={password}
                 onChange={(e) => setPassword(e.target.value)}
                 placeholder="Your password"
                 autoComplete="current-password" required/>
        </div>
        <button className="btn" type="submit" disabled={busy}>
          {busy ? "Signing in…" : "Sign in"}
        </button>

        <div className="auth-link">
          <Link to="/forgot">Forgot password?</Link>
          <Link to="/signup">Create an account</Link>
        </div>

        <button type="button" className="btn btn-secondary" style={{ marginTop: 4 }}
                onClick={() => setShowDemo(true)}>
          🔑 Show demo login details
        </button>

        <div style={{ textAlign: "center", marginTop: 16, fontSize: 11, color: "var(--text-3)" }}>
          © 2026 Gaurav Singh Thakur
        </div>
      </form>

      {showDemo && (
        <div className="modal-backdrop" onClick={() => setShowDemo(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()} style={{ width: 420 }}>
            <h3>Welcome to the Sage demo 👋</h3>
            <p className="text-2" style={{ fontSize: 13, marginTop: -4, marginBottom: 14 }}>
              Pick an account to try it — click <strong>Use</strong> and it fills the form, then press <strong>Sign in</strong>.
            </p>

            {DEMO_ACCOUNTS.map((acc) => (
              <div key={acc.email} className="card" style={{ padding: 12, marginBottom: 10 }}>
                <div className="flex between items-center">
                  <div>
                    <div style={{ fontWeight: 700 }}>{acc.role}</div>
                    <div className="text-3" style={{ fontSize: 11 }}>{acc.note}</div>
                  </div>
                  <button type="button" className="btn" style={{ padding: "6px 14px", fontSize: 13 }}
                          onClick={() => fillAccount(acc)}>Use</button>
                </div>
                <div className="text-2" style={{ fontSize: 12, marginTop: 8 }}>
                  <code>{acc.email}</code> · <code>{acc.password}</code>
                </div>
              </div>
            ))}

            <div className="text-3" style={{ fontSize: 11, marginTop: 4 }}>
              This is a shared demo — please don't store real data. You can change the
              password anytime from Settings.
            </div>

            <div className="flex" style={{ justifyContent: "flex-end", marginTop: 14 }}>
              <button type="button" className="btn btn-secondary" onClick={() => setShowDemo(false)}>Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
